import React from 'react';
import Create from '../../rest/Create';
import Form from '../components/Form';

const MistakeTypesCreate = props => (
  <Create {...props} resource="mistakeTypes">
    <Form />
  </Create>
);

MistakeTypesCreate.propTypes = {};

export default MistakeTypesCreate;
